import { render, staticRenderFns } from "./invoiceForm.vue?vue&type=template&id=21bfc1f4&scoped=true&"
import script from "./invoiceForm.vue?vue&type=script&lang=js&"
export * from "./invoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./invoiceForm.vue?vue&type=style&index=0&id=21bfc1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfc1f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21bfc1f4')) {
      api.createRecord('21bfc1f4', component.options)
    } else {
      api.reload('21bfc1f4', component.options)
    }
    module.hot.accept("./invoiceForm.vue?vue&type=template&id=21bfc1f4&scoped=true&", function () {
      api.rerender('21bfc1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/invoiceForm.vue"
export default component.exports